import React from 'react';
import { useTranslation } from 'react-i18next';
import { FilterMinimalStyleCircle88 } from 'shared/assets/icons';
import { EmptyState, IconSizes } from 'shared/components/ui/empty-state';

export const SmartListEmptyState: React.FC = () => {
  const { t } = useTranslation();

  return (
    <EmptyState
      icon={FilterMinimalStyleCircle88}
      title={t('views.tasks-list.smart-list-empty-state.title')}
      iconSize={IconSizes.Large}
    />
  );
};
